import { registerSharedModules } from 'remote-components/host/html';

registerSharedModules({
    // Override built-in polyfills with your own modules
    // This override fixes chat in the prospect navigation
    "next/navigation": () => Promise.resolve({
        useRouter() {
            return {
                push: (url) => window.location.assign(url),
                replace: (url) => history.replaceState({}, "", url),
                back: () => history.back(),
            };
        },
        usePathname: () => location.pathname,
        useSearchParams: () => new URLSearchParams(location.search),
        __esModule: true,
    }),
});

export * from "remote-components/host/html";